export class TwoFaClient {
  constructor(
    public hasValidApiKey: boolean,
    public hasActiveProtocol: boolean,
    public expireTsLastApiKey?: moment.Moment,
    public createTsLastApiKey?: moment.Moment,
    public renewCounterApiKey?: number,
    public maxRenewCounterApiKey?: number,
  ) {}
}

export class TwoFaClientPassword {
  constructor(
    public id: number,
    public apiKey: string,
    public hasActiveProtocol: boolean,
    public expireTs?: moment.Moment,
    public createTs?: moment.Moment,
    public renewCounterApiKey?: number,
    public maxRenewCounterApiKey?: number,
    

  ) {}
}

export class WebMailInfo {
  constructor(public redirectPGA: string, public redirectWebMail: string) {}
}
